import React from 'react';
import styles from 'assets/styles/components/abrdn-list.module.scss';

const FundDetailsList = ({ data }: { data: string[] }) => {
  return (
    <ul className={styles['abrdn-list']}>
      {data.map((item) => (
        <li key={item} className="body-default">
          {item}
        </li>
      ))}
    </ul>
  );
};

export default FundDetailsList;
